import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { useAuth } from "../context/authContext";

const Home = () => {
    const { accountId } = useAuth();
    const [accounts, setAccounts] = useState([]);

    const isWalletConnected = async () => {
        if (!window.ethereum) return false;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_accounts' });
            setAccounts(accounts);
        } catch (err) {
            console.error("Error checking wallet connection:", err);
        }
    };

    useEffect(() => {
        isWalletConnected();
    }, [accountId]);

    return (
        <>
            <div className="row m-0" style={{ background: "rgb(177 72 76)" }}>
                <div className="col-lg-6 position-relative overflow-hidden cus-login-height bg-dark-200 d-none d-lg-block">
                    <div className="circle-top"></div>
                    {/* <div><img src="/assets/images/logo-icon.svg" alt="Logo-Dark" className="circle-bottom" /></div> */}
                    <div className="d-flex align-items-center z-1 position-relative h-n80">
                        <div className="row justify-content-center w-100">
                            <div className="col-lg-7">
                                <h2 className="text-white f-s-40 m-b-16 m-t-0 lh-base"> Welcome to <br /> Tether Mine </h2>
                                <span className="op-75 f-s-16 text-white d-block m-b-16 lh-base"> Tether Mine helps developers to build organized and well coded <br /> dashboards full of beautiful and rich modules. </span>
                                <button type="button" className="btn btn-cus btn-primary cus-btn-primary0 cus-view-btn-primary">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6" style={{ minHeight: "100vh" }}>
                    <div className="d-flex align-items-start align-items-lg-center justify-content-center h-100">
                        <div className="row p-20 w-100 h-100 align-items-center">
                            <div className="col-lg-9 max-width-form">
                                <Link to={"/login"} ><img src="siteadmin/images/logo2.png" alt="logo" className="align-middle m-2" /></Link>
                                <h4 className="text-white f-w-700 f-s-24 m-t-24 m-b-8">Welcome to Tether Mine</h4>
                                <p className="text-white">Disconnected </p>
                                {accounts[0] && (
                                    <div className="input-group mb-3 w-75">
                                        <input type="text" className="ellipsis-left form-control cus-form-control cus-input-disabled"
                                            value={accounts[0]} disabled
                                        />
                                    </div>
                                )}
                                <div className="row m-t-24">
                                    <div className="d-flex cus-dashborad-button">
                                        {/* <button className=""> */}
                                        <Link to={"/login"} className="btn btn-cus btn-outline-custom mr-3">
                                            {/* <img className="cus-google-icon" src="assets/images/google-icon.svg" alt="Google" />  */}
                                            Connect Again
                                        </Link>
                                        {/* </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home;